var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Cleaning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 6V5L10.125 6.875C10.1083 6.89167 9.975 6.93333 9.725 7C9.55833 7 9.42917 6.92917 9.3375 6.7875C9.24583 6.64583 9.24167 6.5 9.325 6.35L10 5V4C9.71667 4 9.47917 3.90417 9.2875 3.7125C9.09583 3.52083 9 3.28333 9 3C9 2.71667 9.09583 2.47917 9.2875 2.2875C9.47917 2.09583 9.71667 2 10 2H15C15.2833 2 15.5208 2.09583 15.7125 2.2875C15.9042 2.47917 16 2.71667 16 3V3.775C16 3.85833 15.9917 3.92917 15.975 3.9875C15.9583 4.04583 15.9333 4.11667 15.9 4.2L15 6H12ZM10 22C9.45 22 8.97917 21.8042 8.5875 21.4125C8.19583 21.0208 8 20.55 8 20V15.075C8 14.9083 8.01667 14.7458 8.05 14.5875C8.08333 14.4292 8.14167 14.275 8.225 14.125L11.425 8.075C11.6083 7.74167 11.8542 7.47917 12.1625 7.2875C12.4708 7.09583 12.8167 7 13.2 7H15C15.2833 7 15.5208 7.09583 15.7125 7.2875C15.9042 7.47917 16 7.71667 16 8V20C16 20.55 15.8042 21.0208 15.4125 21.4125C15.0208 21.8042 14.55 22 14 22H10Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaning);
export default __webpack_public_path__ + "static/media/cleaning.9dd67b6cb6debfc2b157ee7288be681c.svg";
export { ForwardRef as ReactComponent };